import type React from 'react';
import Input from '../Input';
import Select from '../Select';
import { EGYPTIAN_GOVERNORATES } from './constants';
import type { ScholarshipFormData, FormErrors } from './types';

interface StepPersonalProps {
  values: ScholarshipFormData;
  errors: FormErrors;
  onChange: (name: keyof ScholarshipFormData, value: string) => void;
  onBlur: (name: keyof ScholarshipFormData) => void;
}

export default function StepPersonal({
  values,
  errors,
  onChange,
  onBlur,
}: StepPersonalProps) {
  const handleChange =
    (name: keyof ScholarshipFormData) =>
    (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
      onChange(name, e.target.value);
    };

  const handleBlur = (name: keyof ScholarshipFormData) => () => {
    onBlur(name);
  };

  return (
    <div className="space-y-6">
      {/* Title & Subtitle */}
      <div>
        <h2 className="text-xl sm:text-2xl font-bold text-[#2C2C2C] mb-2">
          خلينا نعرفك الأول
        </h2>
        <p className="text-sm text-[#707070] leading-relaxed">
          اكتب بيانات التواصل الأساسية عشان نقدر نتواصل معاك بعد مراجعة طلبك.
        </p>
      </div>

      <div className="space-y-4">
        {/* Full Name */}
        <Input
          name="full_name"
          label="الاسم بالكامل"
          required
          placeholder="مثال: أحمد محمد علي"
          value={values.full_name}
          error={errors.full_name}
          onChange={handleChange('full_name')}
          onBlur={handleBlur('full_name')}
          className="text-base"
        />

        {/* Email */}
        <Input
          name="email"
          label="البريد الإلكتروني"
          required
          type="email"
          inputMode="email"
          autoComplete="email"
          dir="ltr"
          placeholder="name@example.com"
          value={values.email}
          error={errors.email}
          onChange={handleChange('email')}
          onBlur={handleBlur('email')}
          className="text-start text-base"
        />

        {/* Phone */}
        <Input
          name="phone"
          label="رقم الموبايل"
          type="tel"
          inputMode="tel"
          autoComplete="tel"
          dir="ltr"
          placeholder="01xxxxxxxxx أو رقم دولي"
          value={values.phone}
          error={errors.phone}
          onChange={handleChange('phone')}
          onBlur={handleBlur('phone')}
          className="text-start text-base"
        />

        {/* Date of Birth */}
        <Input
          name="date_of_birth"
          label="تاريخ الميلاد"
          required
          type="date"
          dir="ltr"
          value={values.date_of_birth}
          error={errors.date_of_birth}
          onChange={handleChange('date_of_birth')}
          onBlur={handleBlur('date_of_birth')}
          className="text-start text-base"
        />

        {/* Governorate */}
        <Select
          name="governorate"
          label="المحافظة"
          required
          placeholder="اختر المحافظة"
          options={EGYPTIAN_GOVERNORATES}
          value={values.governorate}
          error={errors.governorate}
          onChange={handleChange('governorate')}
          onBlur={handleBlur('governorate')}
          className="rounded-xl border-2 border-gray-200 focus:border-[#5B3FD0] focus:ring-4 focus:ring-[#5B3FD0]/10 text-base"
        />
      </div>
    </div>
  );
}
